export const MAIN_CLASS_NAME = 'project-document-list';
export const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
